export interface IContactState {
    fetchContactsLoading: boolean
    items: IContactsResponse
    deleteContactLoading: boolean
    content: IContactUsContent
    contentLoading: boolean
}

export interface IContactsResponse {
    total_pages: number
    count: number
    data: IContact[]
}

export interface IContact {
    id: string
    created_at: string
    name: string
    email: string
    message: string
    responded: boolean
}

export const initialContactsResponse = {
    total_pages: 0,
    count: 0,
    data: []
}

export interface IContactUsContent {
    lat: number
    lng: number
    phone?: string
    email: string
    address: string
    pin_tooltip: string
}

export const initialContactUsContent: IContactUsContent = {
    address: "", email: "", lat: 41.9981, lng: 21.4254, phone: "", pin_tooltip: ""
}

